import React, { ChangeEventHandler, KeyboardEventHandler } from 'react'

type TextInputProps = {
  name: string
  label: string
  onKeyUp?: KeyboardEventHandler<HTMLInputElement>
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>
  onChange: ChangeEventHandler<HTMLInputElement>
  placeholder?: string
  value: string
  error: string
  disabled?: boolean
  maxLength?: number | undefined
}

const TextInput = ({
  name,
  label,
  onKeyUp,
  onKeyDown,
  onChange,
  placeholder,
  value,
  error,
  disabled,
  maxLength,
}: TextInputProps) => {
  let wrapperClass = 'form-group'
  if (error && error.length > 0) {
    wrapperClass += ' ' + 'has-error'
  }

  return (
    <div className={wrapperClass}>
      <label htmlFor={name} className="responsive-font">
        {label}
      </label>
      <div className="field">
        <input
          type="text"
          name={name}
          className="form-control responsive-font"
          placeholder={placeholder}
          value={value || ''}
          onKeyUp={onKeyUp}
          onKeyDown={onKeyDown}
          onChange={onChange}
          disabled={disabled}
          maxLength={maxLength}
        />
        {error && (
          <div className="responsive-font alert alert-danger">{error}</div>
        )}
      </div>
    </div>
  )
}

export default TextInput
